<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >supervised_user_circle</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.budget' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      </div>
      <!-- / SEARCH -->


      <div>

        <button mat-button class="mat-icon-button sidenav-toggle mr-12"
          fuseMatSidenavToggler="user-main-sidenav"
          fxHide.gt-lg>
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <mat-sidenav-container class="my-sidenav" style="position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="user-main-sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <filter-menu [filters]="filterData" [page]="'budget'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg"
      [ngClass]="{'margin-big-screen': sidenav.opened}">
      @if (dataSource) {
        <div class="column has-text-centered">
          <table mat-table [dataSource]="dataSource" class="products-table">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef style="width: 30%"> {{'event-preview.date' | translate}} </th>
              <td mat-cell *matCellDef="let element" style="overflow: scroll; white-space: nowrap;">{{element.dates}} </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="width: 35%">{{'event_name' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.title}}</td>
            </ng-container>
            <ng-container matColumnDef="expenses">
              <th mat-header-cell *matHeaderCellDef> {{'outgoings' | translate}} </th>
              <td mat-cell *matCellDef="let element">{{currency}} {{element.expenses}}.-</td>
            </ng-container>
            <ng-container matColumnDef="revenues">
              <th mat-header-cell *matHeaderCellDef > {{'budget.revenues' | translate}} </th>
              <td mat-cell *matCellDef="let element" >{{currency}} {{element.revenues}}.-</td>
            </ng-container>
            <ng-container matColumnDef="outlay">
              <th mat-header-cell *matHeaderCellDef > {{'expense' | translate}} </th>
              <td mat-cell *matCellDef="let element" >{{currency}} {{element.outlay}}.-</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="total">
            <div>{{'Total_expenses' | translate}}</div>
            <div>{{currency}} {{total}}.-</div>
          </div>
        </div>
      }
      @if (!dataSource) {
        <div class="choose-org">
          {{'pls_choose_org' | translate}}
        </div>
      }
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </div>



